import { Overline as e } from "../../../Typography/Typography.mjs";
import { Cell as t, Column as n, Columns as r, ScrollList as i } from "../styled/TimePanel.styled.mjs";
import "react";
import { useTranslation as a } from "@maat/store-i18n";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { parseTime24 as c, toTime24 as l } from "@maat/datetime";
//#region src/components/TimePicker/components/TimePanel.tsx
var u = Array.from({ length: 12 }, (e, t) => t + 1), d = ["AM", "PM"], f = ({ value: f, step: p, onChange: m }) => {
	let { t: h } = a("ds"), g = !!f, _ = f ? c(f) : {
		hour12: 12,
		minute: 0,
		meridiem: "AM"
	}, v = Array.from({ length: Math.ceil(60 / p) }, (e, t) => t * p), y = (e) => m(l(e.hour12, e.minute, e.meridiem));
	return /* @__PURE__ */ s(r, { children: [
		/* @__PURE__ */ s(n, { children: [/* @__PURE__ */ o(e, {
			align: "center",
			children: h("ds:timePicker.hour")
		}), /* @__PURE__ */ o(i, { children: u.map((e) => /* @__PURE__ */ o(t, {
			type: "button",
			$sel: g && _.hour12 === e,
			onClick: () => y({
				..._,
				hour12: e
			}),
			children: e
		}, e)) })] }),
		/* @__PURE__ */ s(n, { children: [/* @__PURE__ */ o(e, {
			align: "center",
			children: h("ds:timePicker.minute")
		}), /* @__PURE__ */ o(i, { children: v.map((e) => /* @__PURE__ */ o(t, {
			type: "button",
			$sel: g && _.minute === e,
			onClick: () => y({
				..._,
				minute: e
			}),
			children: String(e).padStart(2, "0")
		}, e)) })] }),
		/* @__PURE__ */ s(n, { children: [/* @__PURE__ */ o(e, {
			align: "center",
			children: h("ds:timePicker.meridiem")
		}), /* @__PURE__ */ o(i, { children: d.map((e) => /* @__PURE__ */ o(t, {
			type: "button",
			$sel: g && _.meridiem === e,
			onClick: () => y({
				..._,
				meridiem: e
			}),
			children: e
		}, e)) })] })
	] });
};
//#endregion
export { f as TimePanel };
